import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    q: "How do I get more landscaping customers in Colorado?",
    a: "The biggest unlock is showing up in Google Maps for 'landscaping near me' and city-specific searches before spring rush hits. Combined with a website built to capture quote requests and Google Ads timed to seasonal demand, most of our Colorado landscaping clients fill their spring book by February.",
  },
  {
    q: "What's the best time to start SEO for a Colorado landscaping company?",
    a: "October through January. SEO takes 60–120 days to compound, so starting in fall means you're ranking exactly when Coloradans start searching for spring cleanups, install bids, and maintenance contracts.",
  },
  {
    q: "How do I rank in Google Maps for landscaping in Colorado Springs?",
    a: "Optimize your Google Business Profile (categories, services, weekly posts, photos of recent jobs), build a steady stream of Google reviews, and back it up with local citations and city-specific landing pages. Map Pack rankings in Colorado Springs typically firm up in 90–120 days.",
  },
  {
    q: "Should landscapers use Facebook Ads or Google Ads in Colorado?",
    a: "Google Ads for high-intent demand (someone is actively searching). Facebook/Instagram for top-of-funnel awareness and remarketing — especially for higher-ticket design/install work. Most of our landscaping clients run both at modest budgets.",
  },
  {
    q: "How do I generate landscaping leads during the off-season?",
    a: "Run a content + retargeting strategy starting in fall — guides on spring planning, snow removal services, holiday lighting, hardscape design — so you're capturing future-spring buyers months before competitors even start advertising.",
  },
];

export const Route = createFileRoute("/landscaping-seo-colorado")({
  // SEO: consolidate ranking signal onto the /landscaping-marketing-colorado flagship hub.
  head: () => industryMarketingHead("Landscaping", "landscaping", "landscaping-seo-colorado", FAQS, "https://coloradowebimpressions.com/landscaping-marketing-colorado"),
  component: () => (
    <IndustryMarketingPage
      industry="Landscaping"
      industryLower="landscaping"
      slug="landscaping-seo-colorado"
      subheadline="Fill your landscaping schedule before spring even starts — with the right Colorado SEO strategy."
      painPoints={[
        "Booking too late in the season because leads come in slowly from a weak online presence",
        "Competing against large national franchises with massive advertising budgets",
        "No off-season strategy to capture leads and fill the spring calendar early",
      ]}
      serviceDescriptions={{
        seo: "Rank for landscaping, hardscape, irrigation, and design-build searches across Colorado.",
        googleMaps: "Dominate 'landscaper near me' in every neighborhood you serve.",
        webDesign: "Landscaping websites with portfolios that turn browsers into bookings.",
        ppc: "Seasonal Google Ads tuned to spring rush, install demand, and maintenance contracts.",
        geoAi: "Get cited by AI when Coloradans research designers and crews for a project.",
        socialMedia: "Show off jobsite transformations to build trust and earn referrals year-round.",
      }}
      testimonial={{
        quote:
          "Transparent, fast, and they actually pick up the phone. Our website is finally a real sales asset.",
        role: "Landscaping Company Owner",
        city: "Castle Rock",
      }}
      faqs={FAQS}
      industrySpokes={[]}
      cityHubLinks={[
        {
          "to": "/colorado-springs",
          "label": "Landscaping marketing in Colorado Springs",
          "description": "Springs lawn, landscape, and tree-service SEO from our local HQ."
        },
        {
          "to": "/denver-digital-marketing",
          "label": "Landscaping marketing in Denver",
          "description": "Compete in the Denver metro landscape and lawn-care market."
        },
        {
          "to": "/fort-collins-digital-marketing",
          "label": "Landscaping marketing in Fort Collins",
          "description": "Northern Colorado landscape and tree-service SEO."
        }
      ]}
    />
  ),
});
